export default __webpack_public_path__ + "static/media/menu4.334a966f.png";